import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { TeacherCarousel } from '~/src/components/carousels/TeacherCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof TeacherCarousel>['items']) => React.ReactNode;
}
const list = [
  //Rodney Yee
  'OEtp6sqrNDw1UnkYnb5xH',
  //Dianne Bondy
  'teacher_120485',
  //Amy Ippoliti
  '6jS6i3vj1EL7A0f8NdDml0',
  //Luke Ketterhagen
  'teacher_56',
  //Colleen Saidman Yee
  '67kyOKoNLd7rCp6BxPeXLt',
  //Oneika Mays
  '3IAxpzG8tNlDN2Bt59T4jb',
  //Reggie Hubbard
  '1j0rIxXIGKOTyE57URtLg3',
  //Chelsey Korus
  'teacher_1027808',
  //Indu Arora
  'teacher_119252',
  //Jim Bennitt
  'teacher_52549',
  //Anisha Chirmule
  'teacher_2601588',
  //Corina Benner
  'teacher_655476',
  //Sierra Hollister
  'teacher_198834',
  //Miles Borrero
  'teacher_2601648',
  //Carole Westerman
  '75fuhngd3dz68ajfPmuS6O',
  //Cyndi Lee
  'teacher_106',
  //Megan Kearney
  'teacher_993283',
  //Ellen Mosko
  'teacher_2732',
];

export const TeachersCarouselDataEN: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllTeachers_LOH_EN>(graphql`
    query Query_AllTeachers_LOH_EN {
      yi {
        allTeachers(
          filter: {
            ids: [
              "OEtp6sqrNDw1UnkYnb5xH"
              "teacher_120485"
              "6jS6i3vj1EL7A0f8NdDml0"
              "teacher_56"
              "67kyOKoNLd7rCp6BxPeXLt"
              "3IAxpzG8tNlDN2Bt59T4jb"
              "1j0rIxXIGKOTyE57URtLg3"
              "teacher_1027808"
              "teacher_119252"
              "teacher_52549"
              "teacher_2601588"
              "teacher_655476"
              "teacher_198834"
              "teacher_2601648"
              "75fuhngd3dz68ajfPmuS6O"
              "teacher_106"
              "teacher_993283"
              "teacher_2732"
            ]
          }
        ) {
          ...Fragment_TeacherCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allTeachers;
  if (isNil(data)) {
    return null;
  }
  const sortedData = sortCardsByIds(data, list);

  return <>{children(sortedData)}</>;
};
